import { useId } from 'react';

const labels = {
  zh: ['婴儿座椅', '从第一个起，每个 ¥2,000', '不需要', '数量待确认'],
  zh_cn: ['婴儿座椅', '从第一个起，每个 ¥2,000', '不需要', '数量待确认'],
  zh_tw: ['嬰兒座椅', '從第一個起，每個 ¥2,000', '不需要', '數量待確認'],
  ja: ['ベビーシート', '1台目から1台につき2,000円', '不要', '台数要確認'],
  en: ['Infant seats', '¥2,000 per seat, including the first', 'Not needed', 'Confirm quantity'],
  es: ['Sillas para bebé', '¥2,000 por silla, desde la primera', 'No se necesita', 'Confirmar cantidad'],
};

export default function InfantSeatSelector({ value = 0, onChange, language = 'zh' }) {
  const id = useId();
  const copy = labels[language] || labels.en;
  return <div>
    <label htmlFor={id} className="mb-1 block text-sm font-medium text-muted-foreground">{copy[0]}</label>
    <select id={id} name="infant_seat_count" className="premium-input w-full" value={value} onChange={event => onChange(Number(event.target.value))} data-testid="infant-seat-count">
      {value === '' && <option value="" disabled>{copy[3]}</option>}
      {Array.from({ length: 11 }, (_, count) => <option value={count} key={count}>{count === 0 ? copy[2] : count}</option>)}
    </select>
    <p className="mt-1 text-xs text-muted-foreground">{copy[1]}</p>
  </div>;
}
